<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">品牌基地</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            v-if="oldInfos?.id && isRevise"
            @click="addBase"
            class="btn-action"
          >
            新增
          </a-button>
          <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          >
          <!-- <a-button
          @click="importsj()"
          class="btn-action"
          v-if="oldInfos?.id && isRevise"
          >导入</a-button
        > -->
        </span>
      </div>
    </div>

    <!-- :row-selection="rowSelection" -->
    <!-- @change="handleTableChange" -->
    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :scroll="{ y: 290 }"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="sex" slot-scope="text, record, index">
          <span v-if="text == '1'">男</span>
          <span v-else>女</span>
        </template>
        <template slot="izResponse" slot-scope="text, record, index">
          <span v-if="text == '1'">是</span>
          <span v-else>否</span>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 50px"
          v-if="oldInfos?.id"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
            v-if="oldInfos?.id && isRevise"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos?.id && isRevise"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要移除该条品牌基地的数据吗?</p>
    </a-modal>
    <!-- 添加基地 -->
    <AddBrand ref="addBase" @addBrand="addGain"></AddBrand>

    <data-import ref="dataImport" @refreshData="addGain"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>
    
<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
import AddBrand from "./addBrand.vue";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "基地名称",
    dataIndex: "baseName",
    id: "baseName",
    align: "center",
    width: 150,
  },
  {
    title: "基地建设时间",
    dataIndex: "baseFoundTime",
    id: "baseFoundTime",
    align: "center",
    width: 150,
  },
  {
    title: "省",
    dataIndex: "province_dictText",
    id: "province_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "市",
    dataIndex: "city_dictText",
    id: "city_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "区",
    dataIndex: "area_dictText",
    id: "area_dictText",
    align: "center",
    width: 100,
  },
  {
    title: "基地建设地址",
    dataIndex: "baseAddress",
    id: "baseAddress",
    align: "center",
    width: 140,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 244,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      isEdit: false,
      selectedRowKeys: [],
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    AddBrand,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    "oldInfos.brandBaselist": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null) {
          if (
            this.$parent.editInfo &&
            this.$parent.editInfo?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.emptyText = "暂无数据";
          this.addGain();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        // console.log(newValue,'我是')
        this.isEdit = !newValue;
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.addGain();
  },
  methods: {
    showevidence() {
      this.title = "品牌基地";
      this.id = this.oldInfos.id;
      this.showtable = true;
    },
    importsj() {
      this.$refs.dataImport.init("brandBase", this.oldInfos, "品牌基地");
    },
    addGaincz(sj) {
      if (this.oldInfos?.id) {
        this.addGain();
      } else {
        this.pagination.current = 1;
        if (sj.type == "add") {
          sj.record.id = sj.record.num + this.oldInfos.brandBaselist.length;
          this.oldInfos.brandBaselist.push(sj.record);
        } else {
          let index = this.oldInfos.brandBaselist.findIndex(
            (item) => item.id === sj.record.id
          );
          // console.log(sj.record.id,this.oldInfos.brandBaselist);
          if (index !== -1) {
            // 如果找到相同的 id，替换该对象
            this.oldInfos.brandBaselist[index] = sj.record;
          }
        }
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    handleOk() {
      if (this.oldInfos?.id) {
        deleteAction("/lxbase/lxApplyBase/delete", {
          id: this.deteleId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.getData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.success("移除成功");
        this.showDeleteModel = false;
        this.oldInfos.brandBaselist = this.oldInfos.brandBaselist.filter(
          (item) => item.id != this.deteleId
        );
        sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
        this.getData();
      }
    },
    addBase() {
      this.$refs.addBase.init("add", this.oldInfos);
    },
    addBaseActive() {
      this.$refs.addBaseActive.init("add", this.oldInfos);
    },
    addGain() {
      this.pagination.current = 1;
      this.getData();
    },
    getData() {
      if (this.oldInfos?.id) {
        this.loading = true;
        let data = {
          applyType: 2,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxbase/lxApplyBase/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        if (
          this.oldInfos &&
          this.oldInfos.brandBaselist &&
          this.oldInfos.brandBaselist.length > 0
        ) {
          this.pagination.total = this.oldInfos.brandBaselist.length;
          const startIndex =
            (this.pagination.current - 1) * this.pagination.pageSize;
          const endIndex = startIndex + this.pagination.pageSize;
          this.dataList = this.oldInfos.brandBaselist.slice(
            startIndex,
            endIndex
          );
        } else {
          this.dataList = [];
          this.pagination.total = 0;
          this.pagination.current = 1;
        }
      }
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$refs.addBase.init("edit", row);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的品牌基地");
      } else {
        if (this.oldInfos?.id) {
          let params = {
            ids: this.selectedRowKeys.toString(),
          };
          deleteAction("/lxbase/lxApplyBase/deleteBatch", params).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success("批量移除成功");
                this.pagination.current = 1;
                this.getData();
                this.selectedRowKeys = [];
                this.$forceUpdate();
              } else {
                this.$message.error(res.message);
              }
            }
          );
        } else {
          this.pagination.current = 1;
          // console.log(this.selectedRowKeys);
          this.oldInfos.brandBaselist = this.oldInfos.brandBaselist.filter(
            (item) => !this.selectedRowKeys.includes(item.id)
          );
          sessionStorage.setItem("gzs1", JSON.stringify(this.oldInfos));
          this.getData();
          this.selectedRowKeys = [];
        }
      }
    },
  },
};
</script>
    
<style scoped="scoped" lang="scss">
.cotainer {
  .cotainerhead {
    margin: 20px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add-btn {
      width: 100px;
      height: 30px;
      background: #2155b5;
      border-radius: 6px;
      font-weight: 400;
      color: #fff;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}
.table-content {
  margin: 0 auto;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(6),
/deep/.ant-table-tbody > tr > td:nth-child(5) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
</style>